var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kitchen-today"},[_c('kitchen-rule-panel',{attrs:{"date":_vm.date}}),_c('kitchen-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }